import React from 'react';
import { Icon, Drawer, Modal, Tabs, FG, Pagination } from '../components/ui.jsx';
import { api, fmt, fmtD, showToast } from '../api.js';
import { MAT_CAT, MEZZI_CAT, ALL_MAT_CAT, PAGE_SIZE } from '../constants.js';

const CAT_LABELS = {
  camera:'Camera',audio:'Audio',regia:'Regia',kit:'Kit',illuminazione:'Illuminazione',altro:'Altro',
  auto:'Automobile',furgone:'Furgone',van:'Van',carrello:'Carrello',altro_mezzo:'Altro mezzo',
};
const CAT_ICONS = {
  camera:'camera',audio:'mic',regia:'monitor',kit:'package',illuminazione:'zap',altro:'box',
  auto:'car',furgone:'truck',van:'bus',carrello:'container',altro_mezzo:'wrench',
};
const STATUS_COLORS = {disponibile:'#065F46',assegnato:'var(--blue)',manutenzione:'#B87D00',dismesso:'#9CA3AF'};

export const MaterialsPage = () => {
  const [tab, setTab] = React.useState('attrezzature');
  const [mats, setMats] = React.useState([]);
  const [modal, setModal] = React.useState(false);
  const [edit, setEdit] = React.useState(null);
  const [sav, setSav] = React.useState(false);
  const cats = tab === 'mezzi' ? MEZZI_CAT : MAT_CAT;
  const initF = {name:'',category:cats[0]||'altro',description:'',serial_number:'',daily_cost:'',notes:''};
  const [f, setF] = React.useState(initF);

  const load = () => api('/materials').then(d => setMats(d || [])).catch(() => {});
  React.useEffect(() => { load(); }, []);

  const filtered = mats.filter(m => {
    if (tab === 'mezzi') return MEZZI_CAT.includes(m.category);
    return MAT_CAT.includes(m.category) || (!MEZZI_CAT.includes(m.category));
  });

  const openNew = () => {
    setEdit(null);
    setF({...initF, category: cats[0]||'altro'});
    setModal(true);
  };
  const openEdit = m => { setEdit(m); setF({name:m.name,category:m.category,description:m.description||'',serial_number:m.serial_number||'',daily_cost:m.daily_cost||'',notes:m.notes||''}); setModal(true); };
  
  const save = async () => {
    if (!f.name.trim()) { showToast('Nome obbligatorio','warn'); return; }
    setSav(true);
    try {
      if (edit) await api(`/materials/${edit.id}`, 'PATCH', {...f, daily_cost:+(f.daily_cost||0)});
      else await api('/materials', 'POST', {...f, daily_cost:+(f.daily_cost||0)});
      setModal(false); load();
      showToast(edit ? 'Modificato' : 'Aggiunto', 'success');
    } catch(e) {}
    finally { setSav(false); }
  };

  const del_ = async (id, name) => {
    if (!window.confirm('Eliminare "'+name+'"? Azione irreversibile.')) return;
    try { await api('/materials/'+id, 'DELETE'); setModal(false); load(); showToast('Eliminato','success'); }
    catch(e) { showToast(e?.body?.detail||'Errore eliminazione','error'); }
  };

  const updSt = async (id, status) => {
    try { await api(`/materials/${id}`, 'PATCH', {status}); load(); }
    catch(e) {}
  };

  const TABS = [['attrezzature','Attrezzature'], ['mezzi','Parco Mezzi']];
  const countAtt = mats.filter(m => !MEZZI_CAT.includes(m.category)).length;
  const countMez = mats.filter(m => MEZZI_CAT.includes(m.category)).length;

  return (
    <div>
      <div className="page-header">
        <div>
          <div className="page-title">{tab==='mezzi' ? 'Parco Mezzi' : 'Attrezzature'}</div>
          <div className="page-title-sub">
            {tab==='mezzi' ? `${countMez} mezzi aziendali` : `${countAtt} attrezzature`}
          </div>
        </div>
        <button className="btn btn-primary" onClick={openNew}>
          <Icon name="plus" size={14} color="#fff"/>
          {tab==='mezzi' ? 'Nuovo mezzo' : 'Nuova attrezzatura'}
        </button>
      </div>

      <Tabs tabs={TABS} active={tab} onChange={setTab}/>

      <div className="card" style={{padding:0}}>
        <table>
          <thead>
            <tr>
              <th>Nome</th><th>Tipo</th>
              {tab==='mezzi' && <th>Targa / ID</th>}
              {tab!=='mezzi' && <th>Seriale</th>}
              <th>Costo/g</th><th>Stato</th><th></th>
            </tr>
          </thead>
          <tbody>
            {filtered.map(m => (
              <tr key={m.id}>
                <td>
                  <div style={{display:'flex',alignItems:'center',gap:8}}>
                    <Icon name={CAT_ICONS[m.category]||'box'} size={14} color="var(--n400)"/>
                    <span style={{fontWeight:600}}>{m.name}</span>
                  </div>
                  {m.description && <div style={{fontSize:11,color:'var(--n400)',marginTop:2}}>{m.description}</div>}
                </td>
                <td style={{fontSize:12,color:'var(--n400)'}}>{CAT_LABELS[m.category]||m.category}</td>
                <td style={{fontSize:12,color:'var(--n400)'}}>{m.serial_number||'-'}</td>
                <td style={{fontWeight:600,color:'#B87D00'}}>{m.daily_cost>0 ? fmt(m.daily_cost) : '-'}</td>
                <td>
                  <select className="input" style={{width:130,fontSize:11,padding:'3px 8px',
                    color:STATUS_COLORS[m.status]||'var(--n400)',fontWeight:600}}
                    value={m.status} onChange={e=>updSt(m.id,e.target.value)}>
                    {['disponibile','assegnato','manutenzione','dismesso'].map(s=>
                      <option key={s}>{s}</option>)}
                  </select>
                </td>
                <td style={{textAlign:'right'}}>
                  <button className="btn btn-ghost btn-sm" style={{padding:'5px 7px'}}
                    onClick={()=>openEdit(m)}>
                    <Icon name="pencil" size={13} color="var(--n500)"/></button>
                </td>
              </tr>
            ))}
            {!filtered.length && (
              <tr><td colSpan={6} className="empty" style={{padding:30}}>
                <Icon name={tab==='mezzi'?'truck':'package'} size={28} color="var(--n300)"
                  style={{marginBottom:8,display:'block',margin:'0 auto 8px'}}/>
                {tab==='mezzi'
                  ? 'Nessun mezzo registrato — aggiungi il primo'
                  : 'Nessuna attrezzatura — aggiungi la prima'}
              </td></tr>
            )}
          </tbody>
        </table>
      </div>

      {modal && (
        <Modal title={edit
          ? `Modifica — ${edit.name}`
          : tab==='mezzi' ? 'Nuovo mezzo aziendale' : 'Nuova attrezzatura'}
          onClose={()=>setModal(false)}>
          <div className="grid grid-2">
            <FG label="Nome *" span={2}>
              <input autoFocus className="input" value={f.name}
                onChange={e=>setF(p=>({...p,name:e.target.value}))}
                placeholder={tab==='mezzi' ? 'es. Fiat Ducato Bianco' : 'es. Sony FX6'}/></FG>
            <FG label="Tipo">
              <select className="input" value={f.category}
                onChange={e=>setF(p=>({...p,category:e.target.value}))}>
                {cats.map(c=><option key={c} value={c}>{CAT_LABELS[c]||c}</option>)}
              </select></FG>
            <FG label={tab==='mezzi' ? 'Targa / ID' : 'Numero seriale'}>
              <input className="input" value={f.serial_number}
                onChange={e=>setF(p=>({...p,serial_number:e.target.value}))}
                placeholder={tab==='mezzi' ? 'es. CA 123 AB' : ''}/></FG>
            <FG label="Descrizione" span={2}>
              <input className="input" value={f.description}
                onChange={e=>setF(p=>({...p,description:e.target.value}))}/></FG>
            <FG label="Costo/giorno (€)">
              <input type="number" min="0" className="input" value={f.daily_cost}
                onChange={e=>setF(p=>({...p,daily_cost:e.target.value}))}/></FG>
            <FG label="Note">
              <input className="input" value={f.notes}
                onChange={e=>setF(p=>({...p,notes:e.target.value}))}/></FG>
          </div>
          <div style={{display:'flex',justifyContent:edit?'space-between':'flex-end',gap:8,marginTop:12}}>
            {edit && <button className="btn" style={{background:'var(--danger)',color:'#fff'}} onClick={()=>del_(edit.id,edit.name)}>
              <Icon name="trash-2" size={13} color="#fff"/>Elimina</button>}
            <div style={{display:'flex',gap:8}}>
              <button className="btn btn-ghost" onClick={()=>setModal(false)}>Annulla</button>
              <button className="btn btn-primary" onClick={save} disabled={sav}>
                <Icon name="save" size={13} color="#fff"/>{sav ? '...' : 'Salva'}</button>
            </div>
          </div>
        </Modal>
      )}
    </div>
  );
};
